import React from 'react';
import './rodape.css';
import { Mail, MapPin, ArrowRight } from 'lucide-react';

export default function Rodape() {
  return (
    <footer className="rodape">
      <div className="rodape-container">
        
        {/* Agrupador Institucional: Controla o Logo + Texto juntos */}
        <div className="rodape-brand-wrapper">
          {/* COLUNA 1: Logo */}
          <div className="rodape-logo-column">
            <img
              src="/dominio_eletrico_logo_2023_square_fundo_transparente.png"
              alt="Domínio Elétrico Logo"
              className="rodape-logo"
            />
          </div>

          {/* COLUNA 2: Descrição e Contatos */}
          <div className="rodape-info-column">
            <p className="rodape-description">
              Domínio Elétrico é um site dedicado ao ensino de circuitos elétricos, com foco em alunos de engenharia.
            </p>
            <div className="rodape-contact">
              <p><MapPin className="rodape-icon" /> Feito com ⚡ no Brasil</p>
              <p><Mail className="rodape-icon" /> contato@dominioeletrico.com.br</p>
            </div>
          </div>
        </div>

        {/* COLUNA 3: Links de Explorar */}
        <div className="rodape-links-column">
          <h4 className="rodape-links-title">Explorar</h4>
          <ul>
            <li><ArrowRight className="rodape-arrow" /> <a href="/">Início</a></li>
            <li><ArrowRight className="rodape-arrow" /> <a href="/about">Sobre</a></li>
            <li><ArrowRight className="rodape-arrow" /> <a href="/logon">Login</a></li>
            <li><ArrowRight className="rodape-arrow" /> <a href="/blog">Blog</a></li>
          </ul>
        </div>

        {/* COLUNA 4: Links de Ajuda */}
        <div className="rodape-links-column">
          <h4 className="rodape-links-title">Ajuda</h4>
          <ul>
            <li><ArrowRight className="rodape-arrow" /> <a href="/duvidas">Perguntas frequentes</a></li>
            <li><ArrowRight className="rodape-arrow" /> <a href="/contact">Contato</a></li>
            <li><ArrowRight className="rodape-arrow" /> <a href="/termosdeuso">Termos de uso</a></li>
            <li><ArrowRight className="rodape-arrow" /> <a href="/politicadeprivacidade">Política de privacidade</a></li>
            <li><ArrowRight className="rodape-arrow" /> <a href="/antigos">Instruções para alunos antigos</a></li>
          </ul>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="rodape-bottom">
        <p className="rodape-copy">
          © {new Date().getFullYear()} Domínio Elétrico. Todos os direitos reservados.
        </p>
        <p className="rodape-cnpj">
          CNPJ: 44.282.205/0001-82 (N.Y.M.Sugimoto LTDA / Domínio Elétrico)
        </p>
      </div>
    </footer>
  );
}